import { CloseModalHeaderLeftButton } from "src/components/parts/headers/CloseModalHeaderLeftButton"
import { commonModalOptions } from "./commonModalOptions"

export const commonSingleModalOptions = {
  ...commonModalOptions,
  headerLeft: CloseModalHeaderLeftButton,
}
